/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */

export type ClientStrategyCategoryDTOStrategyCategory =
  (typeof ClientStrategyCategoryDTOStrategyCategory)[keyof typeof ClientStrategyCategoryDTOStrategyCategory];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClientStrategyCategoryDTOStrategyCategory = {
  PARTNER: "PARTNER",
  A2A_PROGRAM: "A2A_PROGRAM",
  A2E_PROGRAM: "A2E_PROGRAM",
  BRAND_GUIDELINES: "BRAND_GUIDELINES",
} as const;
